import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetDeviceService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }
  

  Ess_IMEINumberUpdate(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_IMEINumber/Update`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpDetailsOnIMEI(Data: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpDetailsOnIMEI/Number`,
      this.session.SetClass(Data)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
